export default __webpack_public_path__ + "static/media/CS1.431afa71.png";